import { SquareNewWindowIcon } from "@codat/orchard-ui";
import { useFeatureStatus } from "portal-ui-remote/FeatureStatusContext";
import React from "react";
import formatUrl from "utils/formatUrl";

import { paths } from "components/App/paths";
import { SidebarGroup } from "components/Sidebar/Sidebar";
import config from "config";

import { ConnectionIds } from "./CompaniesRoutedPage";

const CompaniesSidebarGroup = (
  companyId: string,
  visualizeEnabled?: boolean,
  dataConnectionIds?: ConnectionIds,
  userPermissions?: string[]
) => {
  const showVisualize =
    visualizeEnabled &&
    (dataConnectionIds?.accountingConnectionId ||
      dataConnectionIds?.commerceConnectionId);

  const { featureStatus } = useFeatureStatus();
  const showNewOnboarding = featureStatus?.["PortalUI.NewOnboardingFlow"];

  const assessGroupName = showNewOnboarding ? "Lending" : "Assess";

  return [
    {
      hasDivider: true,
      items: [
        {
          name: "Summary",
          route: `/companies/${companyId}/summary`,
        },
        {
          name: "Manage connections",
          route: `/companies/${companyId}/connections`,
        },
      ],
    },
    {
      groupName: "Data",
      items: [
        {
          name: "Accounting",
          route: `/companies/${companyId}/accounting`,
        },
        {
          name: "Banking",
          route: `/companies/${companyId}/banking`,
        },
        {
          name: "Commerce",
          route: `/companies/${companyId}/commerce`,
        },
        {
          name: "Uploaded files",
          route: `/companies/${companyId}/files`,
        },
      ],
    },
    {
      groupName: "Data history",
      items: [
        userPermissions?.includes("data_historicDatasets_view") && {
          name: "Read history",
          route: formatUrl(paths.companies.READ_HISTORY, { companyId }),
        },
        userPermissions?.includes("pushOperation_view") && {
          name: "Write history",
          route: formatUrl(paths.companies.WRITE_HISTORY, { companyId }),
        },
      ].filter((x) => x),
    },
    {
      groupName: assessGroupName,
      items: [
        {
          name: "Metrics",
          route: `/companies/${companyId}/assess/metrics`,
        },
        {
          name: "Reports",
          route: `/companies/${companyId}/assess/reports`,
        },
        {
          name: "Upload banking data",
          route: `/companies/${companyId}/assess/upload-banking-data`,
        },
        {
          name: "Categorize accounts",
          route: `/companies/${companyId}/assess/account-categorization`,
        },
      ],
    },
    showVisualize && {
      groupName: "Visualize",
      items: [
        dataConnectionIds?.accountingConnectionId && {
          name: "Accounting",
          route: null,
          href: `${config.VISUALIZE_URL}/company/${companyId}/dataConnection/${dataConnectionIds?.accountingConnectionId}`,
          indicator: <SquareNewWindowIcon />,
        },
        dataConnectionIds?.commerceConnectionId && {
          name: "Commerce",
          route: null,
          href: `${config.VISUALIZE_COMMERCE_URL}/company/${companyId}/dataConnection/${dataConnectionIds?.commerceConnectionId}`,
          indicator: <SquareNewWindowIcon />,
        },
      ].filter(Boolean),
    },
  ].filter(Boolean) as NonNullable<SidebarGroup[]>;
};

export default CompaniesSidebarGroup;
